import PropTypes from "prop-types";
import { useContext } from "react";
import classNames from "classnames";
import ReducedPrice from "./ReducedPrice";
import OriginalPrice from "./OriginalPrice";
import styles from "./index.css";
import getPriceInfo from "./getPriceInfo";
import { withTranslation } from "../../translation";
import TileContext from "../../TileContext";
import { TILE_SIZES } from "../../../helpers/constants";

const { TILE_SIZE_TWO_BY_ONE, TILE_SIZE_TWO_BY_TWO } = TILE_SIZES;

const displayOriginalPrice = (euOmnibusEnabled, isMarkedDown) =>
  euOmnibusEnabled ? !isMarkedDown : true;

const ProductPrice = ({
  price,
  isSale,
  isOutlet,
  reducedPrice,
  hasMultiplePrices,
  labelledById,
  formatTranslation,
  euOmnibusEnabled
}) => {
  const isMarkedDown = isSale || isOutlet;
  const shouldDisplayFrom = hasMultiplePrices && reducedPrice === null;
  const { tileSize } = useContext(TileContext);

  return (
    <p
      id={labelledById}
      aria-hidden={true}
      className={classNames(styles.container, {
        [styles.twoByOne]: tileSize === TILE_SIZE_TWO_BY_ONE,
        [styles.twoByTwo]: tileSize === TILE_SIZE_TWO_BY_TWO
      })}
      aria-label={getPriceInfo({
        price,
        reducedPrice,
        isOutlet,
        hasMultiplePrices,
        formatTranslation,
        euOmnibusEnabled
      })}
    >
      {displayOriginalPrice(euOmnibusEnabled, isMarkedDown) && (
        <OriginalPrice
          price={price}
          isMarkedDown={isMarkedDown}
          isOutlet={isOutlet}
          shouldDisplayFrom={shouldDisplayFrom}
        />
      )}
      {reducedPrice && (
        <ReducedPrice
          isMarkedDown={isMarkedDown}
          reducedPrice={reducedPrice}
          hasMultiplePrices={hasMultiplePrices}
        />
      )}
    </p>
  );
};

ProductPrice.propTypes = {
  price: PropTypes.string.isRequired,
  isSale: PropTypes.bool,
  isOutlet: PropTypes.bool,
  reducedPrice: PropTypes.string,
  hasMultiplePrices: PropTypes.bool,
  labelledById: PropTypes.string.isRequired,
  formatTranslation: PropTypes.func.isRequired,
  euOmnibusEnabled: PropTypes.bool.isRequired
};

ProductPrice.defaultProps = {
  hasMultiplePrices: false,
  isOutlet: false,
  reducedPrice: null,
  isSale: false
};

export default withTranslation(ProductPrice);
